var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    {
      class: [_vm.$style["mds-tr"], _vm.classObject],
      attrs: { "aria-expanded": _vm.ariaExpanded, tabindex: _vm.tabIndex },
    },
    [
      _vm.multiselection && !_vm.isContainer
        ? _c(
            "td",
            { class: [_vm.$style["mds-tr__td--selection"]] },
            [
              !_vm.isTotalNonExpandable
                ? _c("mds-checkbox", {
                    ref: "checkbox",
                    attrs: {
                      label: _vm.multiselectionLabel,
                      value: _vm.multiselectionLabel,
                      indeterminate: _vm.indeterminate,
                      "on-dark": _vm.onDark,
                      size: _vm.size,
                      "hidden-label": "",
                      disabled: _vm.disabled,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.emitChangeEvent($event)
                      },
                    },
                    model: {
                      value: _vm.isChecked,
                      callback: function ($$v) {
                        _vm.isChecked = $$v
                      },
                      expression: "isChecked",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.rowNumber && !_vm.isContainer
        ? _c("td", { class: _vm.$style["mds-tr__td--numbered"] }, [
            !_vm.isTotalNonExpandable
              ? _c("span", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.rowNumber) + "\n        "
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }